import { render, staticRenderFns } from "./SampleCertificateBlankFileSave.vue?vue&type=template&id=1a70cb30&scoped=true&"
import script from "./SampleCertificateBlankFileSave.vue?vue&type=script&lang=js&"
export * from "./SampleCertificateBlankFileSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a70cb30",
  null
  
)

export default component.exports